var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"title-1"},[_vm._v(_vm._s(_vm.$t('404.title')))])])}
var staticRenderFns = []

export { render, staticRenderFns }